'use strict';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
 var newUrl = url;
 newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
  return key + '=' + encodeURIComponent(params[key]);
 }).join('&');

 return newUrl;
}

$('.coupon-missing-error').hide();


/**
 * Checks the total saving chagnes on cart page
 * @param {Object} data - AJAX response from the server
 */

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCheckoutTotals(data, shippingLabel) {
    $('.shipping-item').empty().append(`<div class="col-8">
        <p class="order-receipt-label">${shippingLabel}</p>
    </div><div class="col-4">
        <p class="text-right shipping-cost ">${data.totals.totalShippingCost}</p>
    </div>`);
    $('.grand-total').empty().append(`<div class="col-8">
        <p class="order-receipt-label"><strong>Order Total</strong></p>
       </div><div class="col-4">
        <p class="text-right">
            <span class="grand-total-sum font-weight-bold">
                    ${data.totals.grandTotal}
            </span>
        </p>
    </div>`);
    $('.subtotal-item').empty().append(`<div class="col-8">
        <p class="order-receipt-label">Subtotal</p>
    </div><div class="col-4 end-lines">
        <p class="text-right">${data.totals.subTotal}</p>
    </div>`);
  if($('.order-level-total-discount').length && data.totals.orderLevelDiscountTotal && data.totals.orderLevelDiscountTotal.formatted){
    $('.order-level-total-discount').text(`- ${data.totals.orderLevelDiscountTotal.formatted}`)
  }
    

    data.items.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.checkoutDiscountsHtml);
        }
        $('[data-product-line-item="' + item.UUID + '"] .unit-price').empty().append(item.renderedPrice);
    });
}

$('.checkout-promo-code-form').submit(function (e) {
    e.preventDefault();
    $.spinner().start();
    $('.coupon-missing-error').hide();
    $('.coupon-error-message').empty();
    if (!$('.coupon-code-field').val()) {
     $('.checkout-promo-code-form .form-control').addClass('is-invalid');
     $('.checkout-promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
     $('.coupon-missing-error').show();
     $.spinner().stop();
     return false;
    }
    var $form = $('.checkout-promo-code-form');
    $('.checkout-promo-code-form .form-control').removeClass('is-invalid');
    $('.coupon-error-message').empty();

    $.ajax({
     url: $form.attr('action'),
     type: 'GET',
     dataType: 'json',
     data: $form.serialize(),
     success: function (data) {
      if (data.error) {
       $('.checkout-promo-code-form .form-control').addClass('is-invalid');
       $('.checkout-promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
       $('.coupon-error-message').empty().append(data.errorMessage);
       $('body').trigger('promotion:error', data);
      } else {
       $('.coupons-and-promos').empty().append(data.order.totals.checkoutDiscountsHtml);
       $('.coupon-code-field, .promo-code-submit').addClass('disabled');
       var selectedCountry;
       if ($('#shippingCountrydefault').length) {
        selectedCountry = $('#shippingCountrydefault').val();
       }
       $('body').trigger('checkout:updateCheckoutView',
                      {
                          order: data.order,
                          customer: data.customer
                      }
                  );
       $('body').trigger('promotionCheckout:success', data);
       if ($('#shippingCountrydefault').length && selectedCountry) {
        $('#shippingCountrydefault').val(selectedCountry).trigger('change');
       }
      }
      $('.coupon-code-field').val('');
      $.spinner().stop();
      updateCheckoutTotals(data.order, data.shippingLabel);
      removeCODPayemntMethod('COD', data.removeCOD);
     },
     error: function (err) {
      $('body').trigger('promotion:error', err);
      if (err.responseJSON.redirectUrl) {
       window.location.href = err.responseJSON.redirectUrl;
      } else {
       $.spinner().stop();
      }
     }
    });
    return false;
   });

function removeCODPayemntMethod(paymentID, showStatus) {
    var paymenMethod = document.querySelector(`.payment-options [data-method-id="${paymentID}"]`);

    if (paymenMethod) {
        if (showStatus) {
            paymenMethod.classList.add('hidden');
        } else {
            paymenMethod.classList.remove('hidden');
        }
    }
}
  

$('body').on('click', '.checkout-remove-coupon', function (e) {
    e.preventDefault();
    $('.checkout-delete-coupon-confirmation-btn').trigger('click');
    
   });
 
$('body').on('click', '.checkout-delete-coupon-confirmation-btn', function (e) {
    e.preventDefault();
    $('.checkout-promo-code-form .form-control').removeClass('is-invalid');
    $('.coupon-error-message').empty();
    var url = $('.checkout-delete-coupon-confirmation-btn').data('action');
    var uuid = $('.checkout-remove-coupon').data('uuid');
    var couponCode = $('.checkout-remove-coupon').data('code');
    var urlParams = {
     code: couponCode,
     uuid: uuid
    };
    url = appendToUrl(url, urlParams);
    $('body > .modal-backdrop').remove();

    $.spinner().start();
    $.ajax({
     url: url,
     type: 'get',
     dataType: 'json',
     success: function (data) {
      $('.coupon-uuid-' + uuid).remove();
      $('.coupon-code-field, .promo-code-submit').removeClass('disabled');
      var selectedCountry;
       if ($('#shippingCountrydefault').length) {
        selectedCountry = $('#shippingCountrydefault').val();
       }
      $('body').trigger('checkout:updateCheckoutView',
                     {
                         order: data.order,
                         customer: data.customer
                     }
                 );
      $.spinner().stop();
      $('body').trigger('promotionCheckout:success', data);
      $('.checkout-promo-code-form').removeClass('hidden');
      updateCheckoutTotals(data.order, data.shippingLabel);
      if ($('#shippingCountrydefault').length && selectedCountry) {
        $('#shippingCountrydefault').val(selectedCountry).trigger('change');
       }
        removeCODPayemntMethod('COD', data.removeCOD);
     },
     error: function (err) {
      $('body').trigger('promotion:error', err);
      if (err.responseJSON.redirectUrl) {
       window.location.href = err.responseJSON.redirectUrl;
      } else {
       $.spinner().stop();
      }
     }
    });
   });

   // To get dynamically selected attributes for the items
function getSelectedAttributeHtml(selectedAttributes){
    let html = '';
    if(selectedAttributes.length > 0){
        selectedAttributes.forEach(attribute => {
            html += `<p class="line-item-attributes"><span>${attribute.displayName}</span> ${attribute.displayValue}</p>`;
        });
    }
    return html;
    }
      // Function to get free freebie product and add to cart line item
function addLineItemDyanmically(item){
        let selectedAttributes = getSelectedAttributeHtml(item.variationAttributes);
        let lineItemHtml = `<div class="product-line-item in-stock uuid-${item.UUID}" data-product-line-item="${item.UUID}">
            <div class="product-line-item-details d-flex flex-row">
                <div class="item-image">
                    <img class="product-image" width="80px" height="120px" src="${item.images.small[0].url}" alt="${item.images.small[0].alt}" title="${item.images.small[0].title}">
                    <span class="card-overlay d-none">
                        <strong>${item.availability.messages[0]}</strong>
                    </span>
                </div>
                <div class="item-attributes d-flex flex-column">
                    <div class="line-item-header">
                        <div class="line-item-name">
                            <span>${item.productName}</span>
                        </div>
                    </div>
                    ${selectedAttributes}
                    <div class="item-options"></div>
                    <div class="line-item-unit-price">
                        <p class="line-item-pricing-info"></p>
                        <div class="unit-price">
                            ${item.renderedPrice}
                        </div>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>`
    return lineItemHtml;  
}

$('body').on('promotionCheckout:success', function (e, response) {
        // Add lineitem dynamically to cart page
        const actualItemClasses = [];
        response.order.items.items.forEach(function (item) {
            let itemDyanmicClass = `.uuid-${item.UUID}`;
            actualItemClasses.push(`uuid-${item.UUID}`);
            if (!$(itemDyanmicClass).length) {
                let lineItemHtml = addLineItemDyanmically(item);
                $('.product-summary-block').append(lineItemHtml);
            }
        });

        // Remove once coupon get removed
        const children = $('.product-summary-block').children('.product-line-item');
        const filteredChildren = children.filter(function () {
            return [...this.classList].some(cls => cls.startsWith('uuid-'));
        });
        $('.order-receipt-label.grand-total-label').empty().append(`${actualItemClasses.length} Items`);
        const uuidsArray = filteredChildren.map(function () {
            return [...this.classList].find(cls => cls.startsWith('uuid-'));
        }).get();

        const itemsToRemove = uuidsArray.filter(uuid => !actualItemClasses.includes(uuid));
        itemsToRemove.forEach(function (uuid) {
                $(`.product-line-item.${uuid}`).remove();
            });
    })
 